import { Suspense, useEffect, useState } from "react";
import { getLookupItemData, submitMedicalReportPaymentDetails } from "../../services/epic/medicalReport";
import MedicalReportFee from "./MedicalReportFee";
import UserInfo from "./UserInfo";
import MedicalReportAppointmentResult from "./MedicalReportAppointmentResult";
import { MedicalReportStatus } from "../../utils/constants";
import { getMedicalReportPaymentUrl } from "../../services/payment/payment";
import PaymentModal from "../sickleave/PaymentModal";
import { getMoblieNumberLoginUser, showRelationInMr } from "../../services/liferay/common";
import { capitalizeWords, configureFirstIframe, getLayoutDirection, isArabic, isMobileApp } from "../../utils/util";
import { Loader } from "../../common/Loader";
import renderModal from "./RenderModal";
import WarningInfo from "../../common/WarningInfo";

const RequestMedicalReport = ({
  setRequestStep, userDetails, translationMap,
  mrnValue, specialty, setSpecialty,
  medicalReportErrordMsg, medicalReportAppointmentData, step
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAppointmentSelect, setIsAppointmentSelect] = useState(false);
  const [filterMedicalReportAppointmentData, setFilterMedicalReportAppointmentData] = useState([]);
  const [alternateNumber, setAlternateNumber] = useState();
  const [requestReason, setRequestReason] = useState();
  const [lookUpItem, setLookupItem] = useState();
  const [selectedAppointmentData, setSelectedAppointmentData] = useState(null);
  const [isContinuePayment, setIsContinuePayment] = useState(true);
  const [isAcknowledge, setIsAcknowledge] = useState(false);
  const [specialtyList, setSpecialtyList] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showEligiableMrMessage, setShowEligiableMrMessage] = useState(false);
  const [freeMrLoading, setFreeMrLoading] = useState(false);
  const [showRelationship, setShowRelationship] = useState(true);
  const [relationship, setRelationShip] = useState("");
  const [showLocationErr, setShowLocationErr] = useState(false);
  const [exceptionError, setExceptionError] = useState(false);
  const [errorHeading, setErrorHeading] = useState("");
  const [errorSubHeading, setErrorSubHeading] = useState("");

  useEffect(() => {
    window.parent.scrollTo(0, 0);
    configureFirstIframe(100, 2100, true);
    setShowRelationship(showRelationInMr());
    setSpecialty();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedAppointmentData(null);
  }, [step]);

  useEffect(() => {
    if (selectedAppointmentData && specialty && specialty !== "Select Specialties" && requestReason && requestReason !== "Select Reason" && isAcknowledge) {
      if (showRelationship) {
        if (relationship && relationship !== "Select Relationship") {
          setIsContinuePayment(false);
        } else {
          setIsContinuePayment(true);
        }
      } else {
        setIsContinuePayment(false);
      }
    } else {
      setIsContinuePayment(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAppointmentData, specialty, requestReason, isAcknowledge, relationship, alternateNumber]);

  const selectAcknoledge = () => {
    setIsAcknowledge(!isAcknowledge);
  };

  useEffect(() => {
    setIsLoading(true);

    // console.log("resultData >>>>>>", medicalReportAppointmentData)
    const excludedSpecialties = ["Pharmacy", "Lab", "Radiology"];
    const uniqueSpecialtyData = [
    ...new Set(
      medicalReportAppointmentData
      .map((x) => x.SPECIALTY)
      .filter((specialty) => !excludedSpecialties.includes(specialty))
    )];

    // console.log("uniqueSpecialtyData  >>>>>>>>", uniqueSpecialtyData)
    setSpecialtyList(uniqueSpecialtyData);
    getData();
    setIsLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSelectSpecialty = (event) => {
    setSpecialty(event?.target?.value);
    setShowEligiableMrMessage(false);
    setSelectedAppointmentData(null);
    const selectedValue = event?.target?.value;
    if (selectedValue === 'Select Specialties') {
      setIsAppointmentSelect(false);
    } else {
      setIsAppointmentSelect(true);
    }
    if (medicalReportAppointmentData.length > 0) {
      let filterAppointmentData = medicalReportAppointmentData.filter((item) => {
        return item.SPECIALTY && typeof item.SPECIALTY === 'string' && item.SPECIALTY.toLowerCase() === selectedValue.toLowerCase();
      });
      setFilterMedicalReportAppointmentData(filterAppointmentData);
      let allSelectSpecialtiyFalse = filterAppointmentData.every((appointment) => appointment.isEligible === false);
      setShowEligiableMrMessage(false);
      if (allSelectSpecialtiyFalse) {
        // console.log("Inside not eligiable all");
        setShowEligiableMrMessage(true);
      }
      // console.log("specialty>>>>>>>> filterAppointmentData", filterAppointmentData)
    }
    // console.log("specialty>>>>>>>>", specialty)

  };

  const onSelectReasonValue = (event) => {
    // console.log("Reason value >>>>>", event?.target?.value)
    setRequestReason(event?.target?.value);
  };

  const submitMedicalReport = async () => {
    window.parent.scrollTo(0, 0);
    if (selectedAppointmentData.newLocationId || selectedAppointmentData.newLocationId !== "") {
      setShowPaymentModal(true);
      setRequestStep(1);
    } else {
      setShowLocationErr(true);
    }

  };
  // 60 age above handler
  const handleFreeMedicalReport = async () => {
    if (selectedAppointmentData.newLocationId || selectedAppointmentData.newLocationId !== "") {
      setFreeMrLoading(true);

      let medicalReportResponse = await sbumitMedicalReport(MedicalReportStatus.processed);
      if (medicalReportResponse && medicalReportResponse.data) {

        setTimeout(() => {
          window.parent.scrollTo(0, 0);
          window.parent.location.reload();
        }, 4000);
      } else {
        setFreeMrLoading(false);
      }
    } else {
      setShowLocationErr(true);


    }
  };

  const dateValue = new Date();

  const getData = () => {
    const lookItemRequestBody = { "groupName": "Reason" };
    getLookupItemData(lookItemRequestBody).then((result) => {
      // console.log("Look up item  Result ", result);
      setLookupItem(result.data);
      // setRequestReason(result?.data[0]?.nameEnglish)
    });
  };


  const handlePaymentSumbit = async () => {
    let result = null;
    try {
      result = await sbumitMedicalReport(MedicalReportStatus.initiated);
    } catch (error) {
      console.error(error);
    }

    if (result.status === 200) {
      setIsLoading(true);
      await getMedicalReportPaymentUrl(result.data.id).then((result) => {
        if (result.status === 200) {
          let url = result.data?.url;
          if (url) {
            window.parent.location.href = url;
          }
        }
      })
      .catch((error) => {
        const status = error.response?.status;
        const errorMsg = error.response?.data?.error;

        if (status === 400) {
          setExceptionError(true);
          setErrorHeading(translationMap?.checkSalama ?? "Check details on Salama");
          setErrorSubHeading(translationMap?.[errorMsg] ?? "please verify details");
        } else {
          setExceptionError(true);
          setErrorHeading(translationMap?.somethingWentWrongMesg ?? "Something went wrong. Please try again later.");
          setErrorSubHeading("");

        }
        setIsLoading(false);
      });
    }
  };
  const closePaymentModal = () => {
    setShowPaymentModal(false);
  };


  const sbumitMedicalReport = (status) => {
    // await currentDateParamValue();

    const requestBodyData = {
      "alternateContactNumber": alternateNumber ? alternateNumber : "",
      "contactNumber": getMoblieNumberLoginUser() ? getMoblieNumberLoginUser() : "",
      "cSN": selectedAppointmentData?.CSN,
      "departmentAbbrevation": selectedAppointmentData?.DEPID,
      "departmentId": selectedAppointmentData?.DEPARTMENT_ID + "",
      "departmentName": selectedAppointmentData?.DEPARTMENT,
      "dOB": userDetails?.dateofBirth,
      "doctorId": selectedAppointmentData?.PROVIDER_ID,
      "doctorName": capitalizeWords(selectedAppointmentData?.PROVIDER),
      "facilityName": selectedAppointmentData?.LOCATION,
      "hasPayment": "N",
      "locationId": selectedAppointmentData?.newLocationId + "",
      "medicalReportStatus": status,
      "mRN": mrnValue,
      "otherReasonForApplication": requestReason,
      "otherRelationship": requestReason,
      "patientName": capitalizeWords(`${userDetails?.PatientFirstName ?? ""} ${userDetails?.patientLastName ?? ""}`),
      "reasonForApplication": requestReason,
      "relationship": relationship,
      // "reportGeneratedOn": dateValue,
      "requestDate": dateValue,
      "specialtyName": specialty ? specialty : "",
      "visitDate": new Date(selectedAppointmentData?.APPOINTMENT_TIME).toISOString(),
      "age": userDetails?.age,
      "isNotSeen": true
    };
    const medicalReportRequest = { requestBody: requestBodyData };
    return submitMedicalReportPaymentDetails(medicalReportRequest).then((result) => {
      // console.log("Submit medical details payment  Result ", result);
      if (result.status === 200) {
        return result;
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  if (isLoading) return <Loader />;

  if (freeMrLoading) return <Loader />;


  return (
    <>
            <div className={`${getLayoutDirection()} custombody_color`}>
                <section className="w-100 clearfix MedicalReportMainSection" id="CoverPlanActive">
                    <div className="container customContainer2">
                        {!isMobileApp() &&
            <div className="Title_Inner_Box">
                            <h6 className="MainTitleOne">
                                {translationMap?.requestMedicalReport}
                            </h6>
                        </div>
            }
                        <div className="Step_ul_main_box">
                            <ul className="Step_Info_ul_box">
                                <li>
                                    <div className="Step_inner_box completed_box">
                                        <div className="inner_counter_wrap inner_counter_wrap_filled">
                                <span className="count_box">
                                    <i className="material-symbols-outlined">
                                        check
                                    </i>
                                </span>
                                            <p>
                                                {translationMap?.introduction}
                                            </p>
                                        </div>
                                        <div className="inner_counter_wrap inner_counter_wrap2">
                                            <div className="count_box">
                                                1
                                                <span className="green_circle">
                                        <i className="material-symbols-outlined">
                                            check
                                        </i>
                                    </span>
                                            </div>
                                            <p>
                                                Edit
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="Step_inner_box active_box">
                                        <div className="inner_counter_wrap">
                                             <span className="count_box">
                                             2
                                             </span>
                                            <p>
                                                {translationMap?.request}
                                            </p>
                                        </div>

                                    </div>
                                </li>
                                {userDetails?.age < 60 &&

                <li>
                                        <div className="Step_inner_box ">
                                            <div className="inner_counter_wrap">
                                              <span className="count_box">
                                                3
                                              </span>
                                                <p>
                                                    {translationMap?.payment}
                                                </p>
                                            </div>

                                        </div>
                                    </li>
                }
                            </ul>
                        </div>
                    </div>
                    <div className="container customContainer customContainer3">
                        <div className="cover_inner_wrapper form_cover_inner_wrapper">
                            <div className="cover_main_box1">
                                <div className="medical_main_inner_wrapper">
                                    <div className="form_box">
                                        {medicalReportErrordMsg && <div className="cover_main_box1">
                                            <div className="medical_main_inner_wrapper">
                                                <div className="AlertInnerBox YellowAlertInnerBox fade show">
                                                    <div className="Icon_box">
                                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                        <a href="javascript:void(0);">
                                                            <span className="material-symbols-outlined">info</span>
                                                        </a>
                                                    </div>
                                                    <div className="alert_text">
                                                        <h6>
                                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                            <a href="javascript:void(0);">
                                                                <span className="material-symbols-outlined">info</span>
                                                            </a>
                                                        </h6>
                                                    </div>
                                                    <div className="alert_text">
                                                        <h6>
                              <span>
                                {medicalReportErrordMsg}
                              </span>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                        <div className="Inner_Box">
                                            <div className="row">
                                                <div className="col-12 col-md-12 col-lg-12">
                                                    <MedicalReportFee age={userDetails.age}
                          translationMap={translationMap} />
                                                </div>
                                            </div>
                                        </div>
                                        {exceptionError &&
                    <WarningInfo
                      setError={setExceptionError}
                      alert_text={
                      errorHeading
                      }
                      number_text={
                      errorSubHeading
                      } />

                    }
                                        {userDetails &&
                    <>
                                                <UserInfo userDetails={userDetails} alternateNumber={alternateNumber}
                      setAlternateNumber={setAlternateNumber}
                      translationMap={translationMap}
                      setIsContinuePayment={setIsContinuePayment}
                      setRelationShip={setRelationShip}
                      showRelationship={showRelationship}
                      relationship={relationship} />
                      
                                            </>
                    }
                                        <div className="Inner_Box">
                                            <div className="input_field_box">
                                                <h6 className="Gray_Title Gray_Title2">
                                                    {translationMap?.appointmentDetails}
                                                </h6>
                                                <div className="input_inner_box">
                                                    <div className="row ">
                                                        <div className="col-12 col-md-12 col-lg-12">
                                                            <div className="select_custom_box" id="hockey">
                                                                {/* eslint-disable-next-line no-mixed-operators */}
                                                                {!specialty || specialty === 'Select Specialties' &&
                                <label
                                  for="html">{translationMap.specialty}</label>}
                                                                <div className="dropdown-form">
                                                                    <select
                                    onChange={(event) => onSelectSpecialty(event)}
                                    value={specialty}>
                                                                        <option
                                      value="Select Specialties">{translationMap?.seleclt_specialty}
                                                                        </option>
                                                                        {specialtyList?.map((item, index) => {
                                      return <option key={index}
                                      value={item}>{item} </option>;
                                    })}
                                                                    </select>

                                                                </div>
                                                                {medicalReportAppointmentData && filterMedicalReportAppointmentData &&
                                <MedicalReportAppointmentResult
                                  medicalReportAppointmentData={filterMedicalReportAppointmentData}
                                  selectedAppointmentData={selectedAppointmentData}
                                  setSelectedAppointmentData={setSelectedAppointmentData}
                                  isAppointmentSelect={isAppointmentSelect}
                                  translationMap={translationMap}
                                  showEligiableMrMessage={showEligiableMrMessage} />

                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="Inner_Box">
                                            <div className="input_field_box">
                                                <div className="input_inner_box">
                                                    <div className="row ">
                                                        <div className="col-12 col-md-12 col-lg-6">
                                                            <div className="select_custom_box" id="hockey">
                                                                <label
                                  for="html">{translationMap?.requestReason}</label>
                                                                <div className="dropdown-form">
                                                                    <select
                                    onChange={(event) => onSelectReasonValue(event)}
                                    value={requestReason}>
                                                                        <option
                                      value="Select Reason">{translationMap?.select_reason}
                                                                        </option>
                                                                        {lookUpItem?.map((item, index) =>
                                    <option key={index}
                                    value={item?.nameEnglish}>
                                                                                {isArabic() ? item?.nameArabic : item?.nameEnglish}
                                                                            </option>
                                    )}
                                                                    </select>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="Inner_Box">
                                            <div className="input_field_box">
                                                <h6 className="Gray_Title Gray_Title2">
                                                    {translationMap?.consent}
                                                </h6>
                                                <div className="input_inner_box">
                                                    <div className="row ">
                                                        <div className="col-12 col-md-12 col-lg-12">
                                                            <div className="custom_check_box custom_check_box2">
                                                                <input type="checkbox"
                                onClick={() => selectAcknoledge()}
                                checked={isAcknowledge} className="checkboxField"
                                id="checkbox1" />
                                                                <label
                                  for="checkbox1">{translationMap?.acknowledgement} {translationMap?.acknowledgement1} {translationMap?.acknowledgement2} {translationMap?.acknowledgement3} {translationMap?.acknowledgement4}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="Inner_Box">
                                            <div className="form_buton_box">
                                                <span>
                                                {userDetails?.age >= 60 ? <>
                                                    {freeMrLoading ? <>
                                                        <button disabled={freeMrLoading}
                              className={freeMrLoading ? "disabled_btn_link" : "blue_btn_link"}>
                                
                                                            Loading...
                                                        </button>
                                                    </> : <>
                                                        <button disabled={isContinuePayment}
                              className={isContinuePayment ? "disabled_btn_link" : "blue_btn_link"}
                              onClick={() => handleFreeMedicalReport()}>
                                                            {translationMap?.requestMedicalReport}
                                                        </button>
                                                    </>}

                                                </> : <>
                                                    <button disabled={isContinuePayment}
                            className={isContinuePayment ? "disabled_btn_link" : "blue_btn_link"}
                            onClick={() => submitMedicalReport()}>
                                                        {translationMap?.continueToPayment}
                                                    </button>
                                                </>}
                                                </span>

                                                <span>
                                                      <button onClick={() => setRequestStep(0)}
                          className="bluetrans_btn_link">
                                                        {translationMap?.back}
                                                      </button>
                                                    </span>
                                                <span>
                                                      <button onClick={() => setRequestStep(-1)}
                          className="Orangetrans_btn_link  mrCancelBtn">
                                                        {translationMap?.cancel}
                                                      </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="cover_main_box2">

                            </div>
                        </div>
                    </div>
                </section>
                {
        showLocationErr &&
        renderModal(
          "medicalreport03",
          translationMap?.medicalReport,
          "warning",
          translationMap?.tEligiable,
          translationMap?.locationNotEligiableDesc,
          "",
          () => setShowLocationErr(false),
          translationMap?.close
        )
        }

                {showPaymentModal &&
        <Suspense fallback={<div>Loading...</div>}>
                        <PaymentModal
            show={showPaymentModal}
            close={closePaymentModal}
            handlePaymentSumbit={handlePaymentSumbit}
            headerText={translationMap?.medicalReport}
            certificationFee={270}
            certificationFeeText={translationMap?.mrfee}
            translationMap={translationMap}
            serviceId={''} />
          
                    </Suspense>

        }
            </div>
        </>);

};

export default RequestMedicalReport;